import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}
function cfg() { return { headers: getAuthHeaders(), timeout: 15000 }; }

export async function fetchWatchers(satNum) {
  const base = getBase();
  if (!base || !satNum) return null;
  try {
    const res = await axios.get(base + '/colaboracao/chamado/' + satNum + '/watchers', cfg());
    return res?.data ?? null;
  } catch (err) { return null; }
}
export async function seguirChamado(satNum) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/colaboracao/chamado/' + satNum + '/watch', {}, cfg());
}
export async function deixarDeSeguir(satNum) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/colaboracao/chamado/' + satNum + '/watch', cfg());
}

export async function fetchMencionaveis() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/usuarios/mencionaveis', cfg());
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) { return []; }
}

export async function fetchAvaliacao(satNum) {
  const base = getBase();
  if (!base || !satNum) return null;
  try {
    const res = await axios.get(base + '/colaboracao/chamado/' + satNum + '/avaliacao', cfg());
    return res?.data ?? null;
  } catch (err) { return null; }
}
export async function enviarAvaliacao(satNum, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/colaboracao/chamado/' + satNum + '/avaliacao', body, cfg());
}
